import { Recipe } from '../types';

export const getRecipeIngredientText = (recipe: Recipe): string[] => {
  const ingredient_labels: string[] = [];

  if (recipe.mainIngredient?.label) {
    ingredient_labels.push(
      recipe.mainIngredient?.label
        .replace(/[^\w\s]|_/g, '')
        .toLowerCase()
        .trim()
    );
  }

  return [
    ...ingredient_labels,
    ...recipe.ingredients
      .map((ingr) =>
        ingr.name
          .replace(/[^\w\s]|_/g, '')
          .toLowerCase()
          .trim()
          .split(' ')
      )
      .flat(),
  ];
};
